import React from "react";
import { LogoMark } from "./kzIcons";

const NAV_GROUPS = [
  {
    section: "Work",
    items: [
      { id: "dashboard", label: "Dashboard", icon: "fas fa-table-columns" },
      { id: "request", label: "Request a service", icon: "fas fa-bolt" },
      { id: "track", label: "My jobs", icon: "fas fa-route" },
    ],
  },
  {
    section: "Inbox",
    items: [
      { id: "messages", label: "Messages", icon: "fas fa-comments" },
      { id: "notifications", label: "Notifications", icon: "fas fa-bell" },
    ],
  },
  {
    section: "Account",
    items: [
      { id: "invoices", label: "Invoices", icon: "fas fa-file-invoice" },
      { id: "support", label: "Support", icon: "fas fa-circle-question" },
      { id: "profile", label: "Profile", icon: "fas fa-user" },
    ],
  },
];

const initials = (name) =>
  (name || "C").trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("") || "C";

const HS_CSS = `
.hs { display: flex; flex-direction: column; height: 100%; min-height: 100%; background: #0c0c0b; color: #fff; }
.hs-brand { display: flex; align-items: center; gap: 10px; padding: 22px 20px 18px; font-size: 1.05rem; font-weight: 700; letter-spacing: -.01em; color: #fff; }
.hs-nav { flex: 1; padding: 6px 12px 12px; overflow-y: auto; scrollbar-width: none; }
.hs-nav::-webkit-scrollbar { display: none; }
.hs-group + .hs-group { margin-top: 22px; }
.hs-section { padding: 0 10px 8px; font-size: .74rem; font-weight: 500; color: rgba(255,255,255,.4); }
.hs-item { position: relative; display: flex; align-items: center; gap: 12px; width: 100%; padding: 9px 10px; border: 0; border-radius: 8px; background: transparent; color: rgba(255,255,255,.68); font: inherit; font-size: .88rem; font-weight: 500; text-align: left; cursor: pointer; transition: background .15s, color .15s; }
.hs-item + .hs-item { margin-top: 2px; }
.hs-item i { width: 16px; text-align: center; font-size: .86rem; opacity: .85; }
.hs-item:hover { background: rgba(255,255,255,.07); color: #fff; }
.hs-item.on { background: rgba(255,255,255,.12); color: #fff; font-weight: 600; }
.hs-item.on i { color: #fff000; opacity: 1; }
.hs-item:focus-visible { outline: 2px solid #fff000; outline-offset: 1px; }
.hs-label { flex: 1; }
.hs-badge { min-width: 20px; padding: 1px 6px; border-radius: 10px; background: #fff000; color: #000; font-size: .7rem; font-weight: 700; text-align: center; }
.hs-foot { display: flex; align-items: center; gap: 10px; padding: 14px 16px; border-top: 1px solid rgba(255,255,255,.1); }
.hs-av { display: grid; place-items: center; width: 34px; height: 34px; flex: 0 0 34px; border-radius: 50%; background: #fff000; color: #000; font-size: .78rem; font-weight: 700; }
.hs-who { flex: 1; min-width: 0; }
.hs-who b { display: block; overflow: hidden; font-size: .84rem; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.hs-who span { display: block; color: rgba(255,255,255,.45); font-size: .72rem; }
.hs-out { display: grid; place-items: center; width: 32px; height: 32px; border: 0; border-radius: 8px; background: transparent; color: rgba(255,255,255,.6); cursor: pointer; }
.hs-out:hover { background: rgba(255,255,255,.1); color: #fff; }
.hs-out:focus-visible { outline: 2px solid #fff000; }
`;

export default function HireSidebar({ client, tab, setTab, onClose, onLogout, badges }) {
  const go = (id) => { setTab(id); onClose?.(); };
  const badgeFor = (id) => {
    const n = badges?.[id];
    return typeof n === "number" && n > 0 ? n : null;
  };

  return (
    <div className="hs">
      <style>{HS_CSS}</style>

      <div className="hs-brand"><LogoMark size={26} />KaaKazini</div>

      <nav className="hs-nav" aria-label="Client navigation">
        {NAV_GROUPS.map((group) => (
          <div key={group.section} className="hs-group">
            <div className="hs-section">{group.section}</div>
            {group.items.map((item) => {
              const count = badgeFor(item.id === "track" ? "requests" : item.id);
              const active = tab === item.id;
              return (
                <button
                  key={item.id}
                  type="button"
                  className={`hs-item${active ? " on" : ""}`}
                  onClick={() => go(item.id)}
                  aria-current={active ? "page" : undefined}
                >
                  <i className={item.icon} aria-hidden="true" />
                  <span className="hs-label">{item.label}</span>
                  {count !== null && <span className="hs-badge" aria-label={`${count} new`}>{count > 9 ? "9+" : count}</span>}
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="hs-foot">
        <span className="hs-av" aria-hidden="true">{initials(client?.full_name)}</span>
        <div className="hs-who">
          <b>{client?.full_name || "Client"}</b>
          <span>Client account</span>
        </div>
        {onLogout && (
          <button type="button" className="hs-out" onClick={onLogout} aria-label="Log out" title="Log out">
            <i className="fas fa-right-from-bracket" />
          </button>
        )}
      </div>
    </div>
  );
}
